import React from "react";
import { Link, useLocation } from "react-router-dom";
import { Home, Settings, CalendarDays, User } from "lucide-react";
import { useAuth } from "../context/AuthContext";

export default function Navbar() {
  const location = useLocation();
  const { isLoggedIn, user } = useAuth();
  const isAdmin = location.pathname.startsWith("/admin");

  return (
    <nav className="navbar">
      <div className="navbar-inner">
        {/* Logo */}
        <Link to="/" className="navbar-logo">
          {/*<div className="navbar-logo-icon">
            <CalendarDays />
          </div>*/}
          <span className="navbar-logo-text">rezervioo</span>
        </Link>

        {/* Navigation Links */}
        <div className="navbar-links">
          <Link
            to="/"
            className={`navbar-link ${location.pathname === "/" ? "active" : ""}`}
          >
            <Home />
            <span className="navbar-link-text">Ana Sayfa</span>
          </Link>
          <Link
            to={isLoggedIn ? "/admin" : "/login"}
            className={`navbar-link ${isAdmin || location.pathname === "/login" ? "active" : ""}`}
          >
            <Settings />
            <span className="navbar-link-text">İşletme Paneli</span>
          </Link>

          {/* Giriş yapılmışsa kullanıcı bilgisi */}
          {isLoggedIn && user && (
            <div className="navbar-user">
              <div className={`navbar-user-avatar${user.role === "admin" ? " is-admin" : ""}`}>
                <User />
              </div>
              <span className="navbar-user-name">{user.fullName}</span>
            </div>
          )}
        </div>
      </div>
    </nav>
  );
}